module.exports = {
  __depends__: [
    require(172)
  ],
  __init__: [ 'bpmnKeyBindings' ],
  bpmnKeyBindings: [ 'type', require(21) ]
};
